import React from 'react';
import { Navigate } from 'react-router-dom';
import { format } from 'date-fns';
import { Timestamp } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';

const ProfilePage: React.FC = () => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const createdAt = currentUser.createdAt instanceof Timestamp
    ? currentUser.createdAt.toDate()
    : currentUser.createdAt instanceof Date
      ? currentUser.createdAt
      : new Date(currentUser.createdAt as any);

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Your Profile</h1>

        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="bg-primary-600 px-6 py-8">
            <div className="flex items-center">
              <img
                className="h-20 w-20 rounded-full border-4 border-white"
                src={currentUser.photoURL || `https://ui-avatars.com/api/?name=${currentUser.displayName}&size=80`}
                alt=""
              />
              <div className="ml-6">
                <h2 className="text-2xl font-bold text-white">{currentUser.displayName}</h2>
                <p className="text-primary-200">{currentUser.email}</p>
              </div>
            </div>
          </div>

          <div className="px-6 py-6 space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <p className="text-sm font-medium text-gray-500">Role</p>
                <p className="mt-1 text-gray-900 capitalize">{currentUser.role}</p>
              </div>
              {currentUser.schoolId && (
                <div>
                  <p className="text-sm font-medium text-gray-500">School ID</p>
                  <p className="mt-1 text-gray-900">{currentUser.schoolId}</p>
                </div>
              )}
              <div>
                <p className="text-sm font-medium text-gray-500">Member since</p>
                <p className="mt-1 text-gray-900">{format(createdAt, 'MMMM d, yyyy')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
